export const registerServiceWorker = (): void => {
  if (typeof navigator === 'undefined') return;
  if (!('serviceWorker' in navigator)) return;
  if (window.location.hostname === 'localhost') return;
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js')
      .catch((err) => console.warn('cblix2: sw register failed', err));
  });
};
